import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { JsirLogo } from "../components/Brand";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-sm card p-6">
        <div className="flex flex-col items-center mb-6">
          <JsirLogo className="h-14 w-auto mb-3" />
          <div className="text-sm text-ink-500">Sign in to your DBS workspace</div>
        </div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true); setErr(null);
            try {
              await api.post("/auth/login", { email, password });
              await refresh();
              nav("/dashboard");
            } catch (e: any) { setErr(e.message); }
            finally { setBusy(false); }
          }}
          className="space-y-4"
        >
          <div>
            <label className="label">Email</label>
            <input className="input" type="email" inputMode="email" autoComplete="email" autoCapitalize="off" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label">Password</label>
            <input className="input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {err && <div className="text-sm text-brand">{err}</div>}
          <button className="btn-primary w-full" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <div className="text-sm text-center mt-4 text-ink-500">
          New here? <Link to="/signup" className="text-brand font-medium">Create a workspace</Link>
        </div>
      </div>
    </div>
  );
}
